import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app.routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './account/login/login.component';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { JwtInterceptor } from './helper/jwt.interceptor';
import { AlertComponent, SahredModule } from './common';
import { DashboardComponent } from './account/dashboard/dashboard.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { TenantListComponent } from './account/tenant-list/tenant-list.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { SetPasswordComponent } from './account/set-password/set-password.component';
import { RegisterComponent } from './account/register/register.component';
import { VerifyComponent } from './account/verify/verify.component';
import { PushEnableTileComponent } from './account/push-enable-tile/push-enable-tile.component';
import { ContinueLearningCardComponent } from './account/continue-learning-card/continue-learning-card.component';
import { LmsOverviewCardComponent } from './account/lms-overview-card/lms-overview-card.component';
import { TenantManagementComponent } from './settings/tenant-management/tenant-management.component';
import { TenantSignupsComponent } from './settings/tenant-signups/tenant-signups.component';
import { TenantModulesPickerComponent } from './settings/tenant-modules/tenant-modules-picker.component';
import { NgxEchartsDirective, provideEchartsCore } from 'ngx-echarts';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [	
    AppComponent,
    LayoutComponent,
    LoginComponent,
    AlertComponent,
    DashboardComponent,
    TenantListComponent,
    TenantManagementComponent,
    TenantSignupsComponent,
    ForgetPasswordComponent,
    SetPasswordComponent,
    RegisterComponent,
    VerifyComponent,
    PushEnableTileComponent,
    ContinueLearningCardComponent,
    LmsOverviewCardComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    AppRoutingModule,
    FormsModule,
    SahredModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      titleClass: 'toast-title',
    }),
    TranslateModule.forRoot({
      defaultLanguage: 'en', // or 'en'
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgxEchartsDirective,
    TenantModulesPickerComponent,
  ],
  providers: [
    provideEchartsCore({ echarts: () => import('echarts') }),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    // withInterceptorsFromDi() wires the class-based JwtInterceptor into the root
    // HttpClient so root-provided services (classroom, gradebook, calendar, etc.)
    // send the Bearer token + X-Tenant-ID. Without it those requests 401.
    provideHttpClient(withInterceptorsFromDi()),
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
